export const SUBSCRIPTION_STATE = {
  CURRENT: 'Current',
  RENEWAL: 'Renewal',
}
